import React from "react";
import { Modal } from "@mui/material";
import moment from "moment";
import { DATE_TIME_FORMATS } from "../../../data/constants";

interface Props {
  isOpen: boolean;
  handleClose: (...args: any[]) => void;
  data: any;
}

function SaleSection({ data }: any) {
  return (
    <div className="sale-section">
      <div className="heading bg-[#F2F5FA] text-[#6078A3] text-16 px-24 py-14">
        Sale
      </div>
      <div className="sale-details px-24 flex justify-between w-full">
        <div className="left-section text-15 w-1/2">
          <div className="mb-16 mt-18">
            Source: <span className="font-medium">{data.channel}</span>
          </div>
          <div className="mb-16">
            Channel: <span className="font-medium">{data.channelName}</span>
          </div>
          <div className="mb-18">
            Status: <span className="font-medium">{data.saleStatus}</span>
          </div>
        </div>
        <div className="right-section w-1/2 ml-30 text-15">
          <div className="mb-16 mt-18">
            Sale by:{" "}
            <span className="font-medium">
              {!!data.saleBy?.userName?.firstName &&
                data.saleBy.userName.firstName}
            </span>
          </div>
          <div className="mb-16">
            Order:{" "}
            <span className="font-medium">
              {data?.orderNumber || data?.billNumber || data?.offlineNumber}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

function DiscountSection({ data }: any) {
  return (
    data.discountList?.length && (
      <div className="discount-section">
        <div className="heading bg-[#F2F5FA] text-[#6078A3] text-16 px-24 py-14">
          Sale discounts
        </div>
        {data.discountList.map((discount: any, index: number) => (
          <div
            className="discount-main text-14 font-medium px-24 py-18 border-b flex"
            key={index}
          >
            <div className="discount-name w-1/2">{discount.discountCode}</div>
            <div className="discount-amount">₹{discount.netAmount}</div>
          </div>
        ))}
      </div>
    )
  );
}

function ItemsSection({ data }: any) {
  return (
    <div className="items-section">
      <div className="heading mb-6 bg-[#F2F5FA] text-[#6078A3] text-16 px-24 py-14">
        Items
      </div>
      {data.saleItems.map((item: any, index: number) => {
        return (
          <div
            className="item-main px-24 text-14 py-18 flex justify-between border-b items-center"
            key={index}
          >
            <div className="item-name  font-medium w-1/2">{item.longName}</div>
            <div className="item-quantity w-1/3">X{item.quantity}</div>
            {item.createdBy ? (
              <div className="punching-details text-12 opacity-50 flex flex-col">
                <div className="user-details">
                  By {item.createdBy?.userName?.firstName}{" "}
                  {item.createdBy?.userName?.lastName}
                </div>
                <div className="date whitespace-pre">
                  on{" "}
                  {moment(item.createdBy.date).format(
                    DATE_TIME_FORMATS.dayMonthTime
                  )}
                </div>
              </div>
            ) : null}
          </div>
        );
      })}
    </div>
  );
}

function PrinterLogSection({ data }: any) {
  return (
    data.printLog?.length && (
      <div className="payment-section">
        <div className="heading bg-[#F2F5FA] text-[#6078A3] text-16 px-24 py-14">
          Printer Log
        </div>
        {data.printLog.map((log: any, index: number) => (
          <div
            className="payment-main text-14 font-medium px-24 py-18 border-b flex items-center"
            key={index}
          >
            <div className="payment-name w-1/2">Amount at print</div>
            <div className="payment-amount w-1/3">₹{log.billTotal}</div>
            <div className="punching-details text-12 opacity-50 flex flex-col">
              <div className="user-details">
                By {log.eventBy?.userName?.firstName}{" "}
                {log.eventBy?.userName?.lastName}
              </div>
              <div className="date whitespace-pre">
                on{" "}
                {moment(log.eventBy?.date).format(
                  DATE_TIME_FORMATS.dayMonthTime
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    )
  );
}

function ChargesSection({ data }: any) {
  return (
    <div className="charges-section">
      <div className="heading bg-[#F2F5FA] text-[#6078A3] text-16 px-24 py-14">
        Charges
      </div>
      {data.chargeList.map((charge: any, index: number) => {
        return (
          <div
            className="charge-main text-14 font-medium px-24 py-18 border-b flex"
            key={index}
          >
            <div className="charge-name w-1/2">{charge.name}</div>
            <div className="charge-amount">₹{charge.netAmount}</div>
          </div>
        );
      })}
    </div>
  );
}

function PaymentSection({ data }: any) {
  return (
    data.paymentInfo?.payments?.length && (
      <div className="payment-section">
        <div className="heading bg-[#F2F5FA] text-[#6078A3] text-16 px-24 py-14">
          Payments
        </div>
        {data.paymentInfo.payments.map((payment: any, index: number) => (
          <div
            className="payment-main text-14 font-medium px-24 py-18 border-b flex items-center"
            key={index}
          >
            <div className="payment-name w-1/2">{payment.mode}</div>
            <div className="payment-amount w-1/3">₹{payment.amount}</div>
            <div className="punching-details text-12 opacity-50 flex flex-col">
              <div className="user-details">
                By {payment.paymentBy?.userName?.firstName}{" "}
                {payment.paymentBy?.userName?.lastName}
              </div>
              <div className="date whitespace-pre">
                on{" "}
                {moment(payment.paymentBy.date).format(
                  DATE_TIME_FORMATS.dayMonthTime
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    )
  );
}

function StatusSection({ data }: any) {
  return (
    data.eventLog?.length && (
      <div className="status-section">
        <div className="heading bg-[#F2F5FA] text-[#6078A3] text-16 px-24 py-14">
          Fulfillment status
        </div>
        {data.eventLog.map((status: any, index: number) => (
          <div
            className="status-main text-14 font-medium px-24 py-18 border-b flex justify-between items-center"
            key={index}
          >
            <div className="status-name w-1/2">{status.status}</div>
            <div className="punching-details text-12 opacity-50 flex flex-col">
              <div className="user-details">
                By {status.eventBy?.userName?.firstName}{" "}
                {status.eventBy?.userName?.lastName}
              </div>
              <div className="date whitespace-pre">
                on{" "}
                {moment(status.eventBy?.date).format(
                  DATE_TIME_FORMATS.dayMonthTime
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    )
  );
}

function renderModalData({ data }: { data: any }) {
  return (
    <div className="activity-log-ctn bg-white w-[45vw] smd:w-[90%] rounded-lg max-h-[80vh] relative pb-3">
      <div className="header text-22 p-24 fixed">
        Activity Log - Order #
        {data?.orderNumber || data?.billNumber || data?.offlineNumber}
      </div>
      <div className="activity-log-main overflow-y-scroll mt-[81px] h-[65vh]">
        <SaleSection data={data} />
        {data.saleItems?.length && <ItemsSection data={data} />}
        {data.chargeList?.length && <ChargesSection data={data} />}
        {!!data.discountList?.length && <DiscountSection data={data} />}
        {!!data.paymentInfo?.payments?.length && <PaymentSection data={data} />}
        {!!data.eventLog?.length && <StatusSection data={data} />}
        {!!data.printLog?.length && <PrinterLogSection data={data} />}
      </div>
    </div>
  );
}

function ActivityLog({ isOpen, handleClose, data = {} }: Props) {
  return (
    <Modal
      className="flex justify-center items-center"
      open={isOpen}
      onClose={handleClose}
    >
      {renderModalData({ data })}
    </Modal>
  );
}

export default ActivityLog;
